import { PERMISSIONS } from './authManager';

export const INSIGHT_TAB_PERMISSIONS = {
  overview: PERMISSIONS.INSIGHTS_OVERVIEW_READ,
  leakage: PERMISSIONS.INSIGHTS_OVERVIEW_READ,
  channels: PERMISSIONS.INSIGHTS_OVERVIEW_READ,
  staff: PERMISSIONS.INSIGHTS_STAFF_READ,
  network: PERMISSIONS.INSIGHTS_NETWORK_READ,
  arrivals: PERMISSIONS.INSIGHTS_OPERATIONS_READ,
  ops: PERMISSIONS.INSIGHTS_DATA_INPUT_MANAGE,
};

export const INSIGHTS_PAGE_PERMISSIONS = [
  ...new Set(Object.values(INSIGHT_TAB_PERMISSIONS)),
];

export const INSIGHTS_BUDGET_PERMISSIONS = [
  PERMISSIONS.INSIGHTS_BUDGET_MANAGE,
  PERMISSIONS.INSIGHTS_DATA_INPUT_MANAGE,
];
